import { inArray } from '@Config'
import { get } from 'lodash'
import { autorun, makeAutoObservable, runInAction } from 'mobx'
import { storeFilter } from './StoreFilter'
import Customer from './User/Customer'

class StoreProfile {
    profileData = null
    successTrackerData = null
    commissionData = null
    facebookLoginData = null
    seminarData = null
    addressBookData = null
    orderHistoryData = null
    genealogyData = null
    lsbData = null
    editBaInfo = false
    saveBaInfo = false
    editForms = {
        homePhone: '',
        mobilePhone: '',
        workPhone: '',
        email: '',
        hasError: false
    }
    periodSelected = 0
    periods = []
    globalCardWidth = 'card-354'
    needReload = false
    genealogyAge = 0
    genealogyCache = false
    isStatusE = false
    isViewBa = false
    profileDataReady = false
    genealogyDataReady = false
    dataReady = false
    rankSelected = ''

    boxProfileHeight = 0
    boxBaInfoHeight = 0
    boxSeminarHeight = 0
    boxGenealogyHeight = 0
    boxOrderHistoryHeight = 0
    boxSuccessTrackerHeight = 0
    boxCommissionHeight = 0
    boxLsbHeight = 0

    closeHeaderMenu = false

    enroller = null
    sponsor = null

    seminarHeaderTab = 0

    currentProfileData = null

    profileChanged = false

    userMarket = null

    distStatus = ''

    setDistStatus(value) {
        this.distStatus = value
    }

    setProfileData(value) {
        this.profileData = value
        this.currentProfileData = new Customer(this.profileData)
        this.profileDataReady = true
    }

    setCommission(value) {
        this.commissionData = value
    }

    setLsb(value) {
        this.lsbData = value
    }

    setOrderHistoryData(value) {
        this.orderHistoryData = value
    }

    setData(profile, commission, lsb) {
        this.profileData = profile
        this.currentProfileData = new Customer(this.profileData)
        this.commissionData = commission
        this.lsbData = lsb
        this.profileDataReady = true
    }

    InitDashboardData(data, isViewBa) {

        this.genealogyData = data.genealogy
        this.successTrackerData = data.achievementsHistory
        
        this.genealogyAge = data.age
        this.genealogyCache = data.located

        if (isViewBa) {
            this.currentProfileData = null
            this.setProfileData(data.genealogy.items[0].customer)
        }
    }

    setCPWE(value) {
        this.isCPWE = value
    }
    /**
     * @return {Customer} Customer
     */
    CustomerData() {
        if (this.currentProfileData) {
            return this.currentProfileData
        } else {
            this.currentProfileData = new Customer(this.profileData)
        }

        return this.currentProfileData
    }

    isDataReady() {
        let dataReady = false
        if (this.profileDataReady === true && this.genealogyDataReady === true) {
            dataReady = true
        } else {
            dataReady = false
        }

        runInAction(() => {
            this.dataReady = dataReady
        })

        return dataReady
    }

    resetDataReady() {
        runInAction(() => {
            this.profileDataReady = false
            this.genealogyDataReady = false
            this.dataReady = false
        })
    }

    resetData() {
        runInAction(() => {
            if (/genealogy\/dashboard/.test(window.location.pathname)) {
                this.profileData = null
                this.successTrackerData = null
                this.genealogyData = null
            }

            this.commissionData = null
            this.facebookLoginData = null
            this.seminarData = null
            this.addressBookData = null
            this.orderHistoryData = null
            this.enroller = null
            this.sponsor = null
            this.profileDataReady = false
            this.genealogyDataReady = false
            this.dataReady = false
            this.seminarHeaderTab = 0
        })
    }

    ShowSeminar() {
        return !inArray(this.userMarket, ['VNM'])
    }

    setEnrollerSponsor() {}

    setUserMarket(value) {
        this.userMarket = value
    }

    constructor() {
        makeAutoObservable(this)

        autorun(r => {
            if (get(this.profileData, 'id.unicity', null) !== get(this.currentProfileData, 'id.unicity', null)) {
                this.currentProfileData = new Customer(this.profileData)

                r.dispose()
            }
        })
    }
}

export default new StoreProfile()
